module.exports = __webpack_public_path__ + "img/communicada-white-side-by-side.f6bf1159.png";